export type ShareTarget = {
  email: string;
  service: string;
};

const SERVICE_LABELS: [RegExp, string][] = [
  [/drive\.google/, "Google Drive"],
  [/docs\.google/, "Google Docs"],
  [/dropbox/, "Dropbox"],
  [/pinterest/, "Pinterest"],
  [/behance/, "Behance"],
  [/figma/, "Figma"],
];

const GOOGLE_DRIVE_TARGET: ShareTarget = {
  email: "admin@nolimitcreatives.com",
  service: "Google Drive",
};

const DROPBOX_TARGET: ShareTarget = {
  email: "teams@nlc.com",
  service: "Dropbox",
};

function hostnameOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/** The account a link must be shared with so the designer can open it. */
export function getShareTarget(url: string): null | ShareTarget {
  if (/drive\.google|docs\.google/.test(url)) return GOOGLE_DRIVE_TARGET;
  if (/dropbox/.test(url)) return DROPBOX_TARGET;

  return null;
}

export function getLinkMeta(url: string): { label: string; shortUrl: string } {
  const hostname = hostnameOf(url);
  const service = SERVICE_LABELS.find(([pattern]) => pattern.test(hostname));

  return {
    label: service?.[1] ?? hostname,
    shortUrl: url.replace(/^https?:\/\/(www\.)?/, ""),
  };
}
